var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alert"},[_c('alert-detail',{attrs:{"id":_vm.id},on:{"close":function($event){return _vm.$router.push({ name: 'alerts' })}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }